// extracted by mini-css-extract-plugin
var _1 = "V94Jb";
var _2 = "P0w5K";
var _3 = "t3Ldo";
export { _1 as "collapsible", _2 as "details", _3 as "detailsTrigger" }
